import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { t } from "i18next";
import { BROKER_DASHBOARD, MAINTENANCE_BANNER } from "utils/constants/Routes";
import {
  useBrokerMasterDetails,
  Carrier,
  CarrierID,
} from "@sentara-health/sentara-api-hooks-core";
import { useAuth, useGlobalState, useOidcAuth, useBranding, Brands } from "providers";
import { isUnAuthorizedUser, loadSfmcBannerScript } from "utils/helpers/HelperFn";

interface Prop {
  children: React.ReactNode;
  auth?: boolean;
}

export const ProtectedRoute = (prop: Prop) => {
  const { getBrokerMasterDetails } = useBrokerMasterDetails();
  const { setPageLoader, HideErrorMessage, isShowErrorMessage } = useGlobalState();
  const { user: userODIC, removeUser } = useOidcAuth();
  const { user, isAccess, accessFeatures, updateUser, updateToken, signOut } =
    useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { brandConfig } = useBranding();

  const redirectToLogin = () => {
    const { pathname, search } = location;
    sessionStorage.setItem("redirectTo", `${pathname}${search}`);
    navigate("/");
  };

  // useEffect(() => {
  //   const observer = new MutationObserver(() => {
  //     const closeButton = document?.querySelector(
  //       "#maintenanceBanner .btn-link.border-0.bg-transparent.d-inline-flex.align-items-center.text-decoration-none"
  //     );
  //     if (closeButton) {
  //       closeButton.addEventListener("click", HideErrorMessage);
  //       observer.disconnect();
  //     }
  //   });
  //   observer.observe(document?.body, { childList: true, subtree: true });

  //   return () => {
  //     observer.disconnect();
  //     const closeButton = document?.querySelector(
  //       "#maintenanceBanner .btn-link.border-0.bg-transparent.d-inline-flex.align-items-center.text-decoration-none"
  //     );
  //     if (closeButton) {
  //       closeButton.removeEventListener("click", HideErrorMessage);
  //     }
  //   };
  // }, [HideErrorMessage]);

  useEffect(() => {
    const callApi = async (loginID: string, carrier: CarrierID) => {
      setPageLoader(
        "brokerMasterDetails",
        true,
        t("brokerMasterDetails.loadingMessages", {
          returnObjects: true,
        }) as string[],
      );
      const brokerDetails = await getBrokerMasterDetails({
        loginId: loginID,
        carrier,
      });
      setPageLoader("brokerMasterDetails", false);

      if (brokerDetails?.data?.result) {
        const _isUnAuthorizedUser = isUnAuthorizedUser(
          brokerDetails.data.result,
          brandConfig.brandName,
          userODIC?.access_token,
        );

        const _isLobsEmpty = brokerDetails?.data?.result.lobs.length === 0;

        if (brandConfig.brandName === Brands.AVMED) {
          let carrier: Carrier = {
            carrierID: 2,
            carrierName: "Avmed",
            carrierShortName: "Avmed",
            effectiveDate: "",
            endDate: "",
          };

          updateUser({
            ...user,
            ...brokerDetails.data.result,
            isUnAuthorizedUser: _isUnAuthorizedUser,
            isLobsEmpty: _isLobsEmpty,
            carrier,
          });
        } else {
          let carrier: Carrier = {
            carrierID: 1,
            carrierName: "Sentara",
            carrierShortName: "Sentara",
            effectiveDate: "",
            endDate: "",
          };

          updateUser({
            ...user,
            ...brokerDetails.data.result,
            isUnAuthorizedUser: _isUnAuthorizedUser,
            isLobsEmpty: _isLobsEmpty,
            carrier,
          });
        }

        if (_isUnAuthorizedUser) {
          navigate("/logout");
        } else if (!brokerDetails.data.result.isSORCurrent) {
          redirectToLogin();
        }
      } else {
        updateUser({
          ...user,
          isUnAuthorizedUser: true,
        });
        navigate("/logout");
      }
    };

    if (user?.loginID && !user.person && !user.isUnAuthorizedUser) {
      callApi(
        user?.loginID,
        brandConfig.brandName === Brands.AVMED
          ? CarrierID.AV_MED
          : CarrierID.SENTARA,
      );
    }
  }, [user]);

  useEffect(() => {
    if (userODIC?.access_token && userODIC?.profile?.upn && !user?.loginID) {
      updateUser({
        ...{
          loginID: (userODIC?.profile?.upn as string).toString().split("@")[0],
          userDetailsFromOidc: userODIC,
        },
      });
      updateToken(userODIC?.access_token);
    } else if (userODIC?.id_token && !user) {
      removeUser();
      signOut("/");
    }
  }, [userODIC]);

  useEffect(() => {
    if (location && accessFeatures) {
      let { pathname } = location;
      pathname = sessionStorage.getItem("redirectTo") ?? pathname;
      sessionStorage.removeItem("redirectTo");

      // if(isShowErrorMessage && accessFeatures && isAccess(`${MAINTENANCE_BANNER}`)) {
      //   loadSfmcBannerScript();
      // }

      if (!isAccess(pathname)) {
        navigate(`/app/${BROKER_DASHBOARD}`);
      }
      if (pathname === "/app") {
        navigate(`/app/${BROKER_DASHBOARD}`);
      }
    }
  }, [accessFeatures]);

  useEffect(() => {
    if (userODIC !== undefined || (!user && userODIC === undefined)) {
      if (!userODIC && !user?.isSORCurrent) {
        redirectToLogin();
      }
    }
  }, [userODIC]);

  return <>{prop.children}</>;
};
